import { ADD_CUSTOM_FORMULA_FAIL, ADD_CUSTOM_FORMULA_REQUEST, ADD_CUSTOM_FORMULA_SUCCESS, ADD_CUSTOM_VARIABLE_FAIL, ADD_CUSTOM_VARIABLE_REQUEST, ADD_CUSTOM_VARIABLE_SUCCESS, ADD_STAGE_FAIL, ADD_STAGE_REQUEST, ADD_STAGE_SUCCESS, ADD_UTM_VARIABLE_FAIL, ADD_UTM_VARIABLE_REQUEST, ADD_UTM_VARIABLE_SUCCESS, DELETE_CUSTOM_FORMULA_FAIL, DELETE_CUSTOM_FORMULA_REQUEST, DELETE_CUSTOM_FORMULA_SUCCESS, DELETE_CUSTOM_VARIABLE_FAIL, DELETE_CUSTOM_VARIABLE_REQUEST, DELETE_CUSTOM_VARIABLE_SUCCESS, DELETE_STAGE_FAIL, DELETE_STAGE_REQUEST, DELETE_STAGE_SUCCESS, DELETE_UTM_VARIABLE_FAIL, DELETE_UTM_VARIABLE_REQUEST, DELETE_UTM_VARIABLE_SUCCESS, GET_CUSTOM_FORMULA_FAIL, GET_CUSTOM_FORMULA_REQUEST, GET_CUSTOM_FORMULA_SUCCESS, GET_CUSTOM_VARIABLE_FAIL, GET_CUSTOM_VARIABLE_REQUEST, GET_CUSTOM_VARIABLE_SUCCESS, GET_LEAD_GEN_VARIABLE_FAIL, GET_LEAD_GEN_VARIABLE_REQUEST, GET_LEAD_GEN_VARIABLE_SUCCESS, GET_STAGE_FAIL, GET_STAGE_REQUEST, GET_STAGE_SUCCESS, GET_UTM_VARIABLE_FAIL, GET_UTM_VARIABLE_REQUEST, GET_UTM_VARIABLE_SUCCESS, UPDATE_CUSTOM_FORMULA_FAIL, UPDATE_CUSTOM_FORMULA_REQUEST, UPDATE_CUSTOM_FORMULA_SUCCESS, UPDATE_CUSTOM_VARIABLE_FAIL, UPDATE_CUSTOM_VARIABLE_REQUEST, UPDATE_CUSTOM_VARIABLE_STATUS_FAIL, UPDATE_CUSTOM_VARIABLE_STATUS_REQUEST, UPDATE_CUSTOM_VARIABLE_STATUS_SUCCESS, UPDATE_CUSTOM_VARIABLE_SUCCESS, UPDATE_STAGE_FAIL, UPDATE_STAGE_REQUEST, UPDATE_STAGE_SUCCESS, UPDATE_UTM_VARIABLE_FAIL, UPDATE_UTM_VARIABLE_REQUEST, UPDATE_UTM_VARIABLE_SUCCESS } from "../constant"

const initialState = {
  customVariableData: [],
  utmVariableData: [],
  customFormulaData: [],
  leadGenData: [],
  stageData: [],

  getCustomVariableLoading: false,
  getUtmVariableLoading: false,
  getCustomFormulaLoading: false,
  getStageLoading: false,
}

const variableReducer = (state = initialState, action) => {
  switch (action.type) {

    //Get Custom Variable
    case GET_CUSTOM_VARIABLE_REQUEST:
      return {
        ...state,
        customVariableData: [],
        getCustomVariableLoading: true
      }
    case GET_CUSTOM_VARIABLE_SUCCESS:
      return {
        ...state,
        customVariableData: action.payload,
        getCustomVariableLoading: false
      }
    case GET_CUSTOM_VARIABLE_FAIL:
      return {
        ...state,
        customVariableData: [],
        getCustomVariableLoading: false
      }

    //Add Custom Variable
    case ADD_CUSTOM_VARIABLE_REQUEST:
      return {
        ...state,
      }
    case ADD_CUSTOM_VARIABLE_SUCCESS:
      return {
        ...state,
      }
    case ADD_CUSTOM_VARIABLE_FAIL:
      return {
        ...state,
      }

    //Update Custom Variable
    case UPDATE_CUSTOM_VARIABLE_REQUEST:
      return {
        ...state,
      }
    case UPDATE_CUSTOM_VARIABLE_SUCCESS:
      return {
        ...state,
      }
    case UPDATE_CUSTOM_VARIABLE_FAIL:
      return {
        ...state,
      }

    //Delete Custom Variable
    case DELETE_CUSTOM_VARIABLE_REQUEST:
      return {
        ...state,
      }
    case DELETE_CUSTOM_VARIABLE_SUCCESS:
      const tmpCustomVarData = state.customVariableData?.filter((variable) => variable.su_custom_variable_id !== action.payload)

      return {
        ...state,
        customVariableData: [...tmpCustomVarData]
      }
    case DELETE_CUSTOM_VARIABLE_FAIL:
      return {
        ...state,
      }

    //Update Custom Variable Status
    case UPDATE_CUSTOM_VARIABLE_STATUS_REQUEST:
      return {
        ...state,
      }
    case UPDATE_CUSTOM_VARIABLE_STATUS_SUCCESS:
      const tmpCustomVariableData = state.customVariableData?.map((variable) => {
        if (Number(variable.su_custom_variable_id) === Number(action.payload.survey_variable_id)) {
          return { ...variable, su_is_required: action.payload.is_req }
        }
        return variable
      })

      return {
        ...state,
        customVariableData: [...tmpCustomVariableData]
      }
    case UPDATE_CUSTOM_VARIABLE_STATUS_FAIL:
      return {
        ...state,
      }

    //Add stage
    case ADD_STAGE_REQUEST:
      return {
        ...state,
      }
    case ADD_STAGE_SUCCESS:
      return {
        ...state,
      }
    case ADD_STAGE_FAIL:
      return {
        ...state,
      }

    //Update stage
    case UPDATE_STAGE_REQUEST:
      return {
        ...state,
      }
    case UPDATE_STAGE_SUCCESS:
      return {
        ...state,
      }
    case UPDATE_STAGE_FAIL:
      return {
        ...state,
      }

    //Delete stage
    case DELETE_STAGE_REQUEST:
      return {
        ...state,
      }
    case DELETE_STAGE_SUCCESS:
      const tmpStage = state.stageData?.filter((stage) => Number(stage.su_survey_stages_id) !== Number(action.payload))
      return {
        ...state,
        stageData: [...tmpStage]
      }
    case DELETE_STAGE_FAIL:
      return {
        ...state,
      }

    //Get stage list
    case GET_STAGE_REQUEST:
      return {
        ...state,
        stageData: [],
        getStageLoading: true
      }
    case GET_STAGE_SUCCESS:
      return {
        ...state,
        stageData: action.payload,
        getStageLoading: false
      }
    case GET_STAGE_FAIL:
      return {
        ...state,
        stageData: [],
        getStageLoading: false
      }


    //Get UTM Variable
    case GET_UTM_VARIABLE_REQUEST:
      return {
        ...state,
        utmVariableData: [],
        getUtmVariableLoading: true
      }
    case GET_UTM_VARIABLE_SUCCESS:
      return {
        ...state,
        utmVariableData: action.payload,
        getUtmVariableLoading: false
      }
    case GET_UTM_VARIABLE_FAIL:
      return {
        ...state,
        utmVariableData: [],
        getUtmVariableLoading: false
      }

    //Add UTM Variable
    case ADD_UTM_VARIABLE_REQUEST:
      return {
        ...state,
      }
    case ADD_UTM_VARIABLE_SUCCESS:
      return {
        ...state,
      }
    case ADD_UTM_VARIABLE_FAIL:
      return {
        ...state,
      }

    //Update UTM Variable
    case UPDATE_UTM_VARIABLE_REQUEST:
      return {
        ...state,
      }
    case UPDATE_UTM_VARIABLE_SUCCESS:
      const tmpUtmVarData = state.utmVariableData?.map((variable) => {
        if (Number(variable.su_suv_id) === Number(action?.payload?.su_suv_id)) {
          return { ...variable, su_var_name: action?.payload?.su_var_name }
        }
        return variable
      })
      return {
        ...state,
        utmVariableData: [...tmpUtmVarData]
      }
    case UPDATE_UTM_VARIABLE_FAIL:
      return {
        ...state,
      }

    //Delete UTM Variable
    case DELETE_UTM_VARIABLE_REQUEST:
      return {
        ...state,
      }
    case DELETE_UTM_VARIABLE_SUCCESS:
      const tmpUtmVariableData = state.utmVariableData?.filter((variable) => Number(variable?.su_suv_id) !== Number(action.payload))
      return {
        ...state,
        utmVariableData: [...tmpUtmVariableData]
      }
    case DELETE_UTM_VARIABLE_FAIL:
      return {
        ...state,
      }

    //Get Custom Formula
    case GET_CUSTOM_FORMULA_REQUEST:
      return {
        ...state,
        getCustomFormulaLoading: true
      }
    case GET_CUSTOM_FORMULA_SUCCESS:
      return {
        ...state,
        customFormulaData: action.payload,
        getCustomFormulaLoading: false
      }
    case GET_CUSTOM_FORMULA_FAIL:
      return {
        ...state,
        getCustomFormulaLoading: false
      }

    //Add Custom Formula
    case ADD_CUSTOM_FORMULA_REQUEST:
      return {
        ...state,
      }
    case ADD_CUSTOM_FORMULA_SUCCESS:
      return {
        ...state,
      }
    case ADD_CUSTOM_FORMULA_FAIL:
      return {
        ...state,
      }

    //Update Custom Formula
    case UPDATE_CUSTOM_FORMULA_REQUEST:
      return {
        ...state,
      }
    case UPDATE_CUSTOM_FORMULA_SUCCESS:
      return {
        ...state,
      }
    case UPDATE_CUSTOM_FORMULA_FAIL:
      return {
        ...state,
      }

    //Delete Custom Formula
    case DELETE_CUSTOM_FORMULA_REQUEST:
      return {
        ...state,
      }
    case DELETE_CUSTOM_FORMULA_SUCCESS:
      const tmpCustomFormulaData = state.customFormulaData?.filter((formula) => formula.su_custom_formula_id !== action.payload)
      return {
        ...state,
        customFormulaData: [...tmpCustomFormulaData]
      }
    case DELETE_CUSTOM_FORMULA_FAIL:
      return {
        ...state,
      }

    //Delete Custom Formula
    case GET_LEAD_GEN_VARIABLE_REQUEST:
      return {
        ...state,
      }
    case GET_LEAD_GEN_VARIABLE_SUCCESS:
      return {
        ...state,
        leadGenData: action.payload,
      }
    case GET_LEAD_GEN_VARIABLE_FAIL:
      return {
        ...state,
      }


    //Default
    default:
      return state;
  }
}

export { variableReducer }